import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";


const Component = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    let response38 = useInvoke("WebApps", "38", {});

    useEffect(() => {

        //get component list
        if (response38.data.payload != undefined) {
            let myData = JSON.parse(response38.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "text", content: {text: `${entry[1]}`}},
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "link", content: {text: `${entry[3]}`, link: `/Component/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[4]}`}},
                {type: "text", content: {text: `${entry[5]}`}}
              ];
              rowsList.push(row);
            });

            setColumns(["Component Category", "Component Type", "Component Name", "Component Description", "Date Added"]);
            setRows(rowsList);

        }

    }, [response38.data.payload]);

    document.title = "Components";
    return ( 
        <div className="components">
            {user["email"] != undefined &&
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Components</h2>
                        <p><Link className="btn btn-primary" to="/Component/New">New Component</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>  
                </>
            }
        </div>
     );
}
 
export default Component;